module.exports={
    "over_size_message":"The image you uploaded is over 10M. We will compress your file for uploading. Please click \"Confirm\" to continue uploading.",
    "file_type_error":"The file you uploaded is not an image! Please try to upload again.",
    "upload_error":"Upload Error! (Error Code: 2000) Please try again.",
    "watermark_remove_over_size":"The image you uploaded is over 5M. It is recommended that you use our Free Online Image Compressor. Click to <a class=\"jump-link\" href=\"https://www.anymp4.com/image-compressor-online/\">learn more</a>",
    "watermark_remove_file_type_error":"The file you uploaded is not a picture, please upload again.",
    "watermark_remove_image_type_error":"The Image format is not supported. We only support JPG, JPEG, PNG and BMP. ",
    "watermark_remove_upload_error":"Recognition error (error code: 2001), please try again...",
    "watermark_remove_processing":"Processing image...",
    "watermark_remove_not_save":"The area you selected will not be retained. Are you sure you want to crop it?",
    "watermark_remove_back_home":"Current status will not be saved. Are you sure you want to go back to Home?",
    "watermark_remove_new_image":"Current status will not be saved. Are you sure you want to choose a new image?",
    "watermark_select":"Select",
    "watermark_select_area":"Please select the area of watermark you want to erase before clicking Remove.",
    "watermark_beyond_4k":"The selected image exceeds 4K resolution. We are sorry we can not process it at present",
    "watermark_beyond_pixel_1":"The selected image resolution exceeds <span>%spx</span><span>&times;%spx</span>. It cannot be processed, please select again.",
    "watermark_beyond_pixel_2":"Visitors can only process <span>%s</span> images with the resolution over <span>%spx</span>x<span>%spx</span>, please login and continue to use.",
    "watermark_beyond_size_1":"The selected image size exceeds <span>%sMB</span>. It cannot be processed, please select again.",
    "watermark_beyond_size_2":"The selected image size exceeds <span>%sMB</span>, but visitors can only process images less than <span>%sMB</span>. Please login and continue to use.",
    "no_user_down":"Visitors can only download <span>%s</span> images with original quality. Please login and continue downloading. Also, you can keep the 7-day history after login. Continue downloading images that are <span>%spx</span> wide or high.",
    "no_down_rights":"Cannot download HD images with original quality, please upgrade your plan! You also can continue to download low-quality images with <span>%spx</span>.",
    "error_40001":"Error: 40001. Please contact us",
    "error_40099":"Error: 40099. Please contact us",
    "down_btn":"Downloading is in preparation, please wait for a second…",
    "noRemove_down_btn":"You have not done anything for removing watermarks. Please select the watermark you want to remove and click the Remove button. Then you can download your image.",
    "history_open":"Opening the modified image, please wait a moment...",
    "maskRightsMonitor_info":"The page for benefits upgrading has been opened in a new tab, and your plan will be auto-synchronized after upgrading.",
    "maskLoginMonitor_info":"The landing page has been opened, please complete the login on it. After logging in or regitering successfully, this page will be synchronized automatically, please do not close it.",
    "photo_rights_info":"<span><i class=\"num\">2</i> HD image(s)</span> with original quality can be downloaded at present. <a href=\"https://account.anymp4.com\" target=\"_blank\">View Details>></a>",
    "rights_original":"To turn on the \"Use the Image Enhancer function to reduce the quality loss\" setting, you need to upgrade your account!",
    "Brush":"Brush",
    "Lasso":"Lasso",
    "Polygonal":"Polygonal",
    "Eraser":"Eraser",
    "Free":"Free",
    "More":"More:",
    "Select":"Select",
    "Remove":"Remove",
    "BrushSize":"Brush Size:",
    "AspectRatio":"Aspect Ratio:",
    "Upload":"New Photo",
    "History":"History",
    "Login":"Login",
    "MyAccount":"My Account",
    "Logout":"Logout",
    "Usinghelp":"Using help>>",
    "Enhancer":"Use the Image Enhancer function to reduce the quality loss",
    "Download":"Download",
    "Guide":"Guide",
    "Polygonal1":"Polygonal:",
    "Polygonal_info":"Click the left mouse button to identify a point at a time.",
    "Lasso1":"Lasso:",
    "Lasso_info":"Long press the left mouse button to lasso the watermark area.",
    "Brush1":"Brush:",
    "Brush_info":"Long press the left mouse button to select precisely.",
    "Eraser1":"Eraser:",
    "Eraser_info":"Erase unnecessary parts from the selected area.",
    "Click":"Click",
    "the":"the",
    "click_info":"button to start effacing the unwanted watermark.",
    "PleaseUploadImages":"Please upload images.",
    "CropInfo":"Once the watermark removing is done, you can click the Crop button to crop your picture before saving, or click the Download button to save the current image directly.",
    "Crop":"Crop",
    "Back":"Back",
    "DownloadCropped":"Download Cropped",
    "Cancel":"Cancel",
    "FreeWatermarkRemover":"Free Watermark Remover",
    "Processing":"Processing...",
    "NewImage":"New Image",
    "Retry":"Retry",
    "Yes":"Yes",
    "No":"No",
    "FailureFeedback":"Failure Feedback",
    "removeTip":"After selecting the watermark area, please click Remove to erase the watermark.",
    "rightDown":"Download Low-quality Images",
    "history_will":"Will expire after",
    "Expired":"(Expired)",
    "uploadImage":"Upload Image",
    "uploadImageInfo":"Or drop your image file here to remove the watermark!",

    "Unlimited":"Unlimited",
    "watermark_beyond_pixel_3":"The selected image exceeds <span>%s&times;%s resolution</span>, please upgrade your plan first.",
    "watermark_beyond_size_3":"The selected image exceeds <span>%sMB</span>, please upgrade your plan first.",
    "no_user_login":"New users who login can gain THREE HD original image downloading benefits.<span class=\"loginMaskbtn\">Login immediately>></span>",
    "Upgrade":"Upgrade",
    "Loading":"Loading…",
    "SelectAll":"Select all",
    "Open":"Open",
    "Delete":"Delete",
    "Clear":"Clear invalid",
    "noHistory":"No History",
    "Close":"Close",
    "buyUserInfo":"ongratulations! You have upgraded successfully. Please return to the home page and use this product.",
    "buyNoUserInfo":"Congratulations! You have upgraded successfully. The benefits have been bound to the e-mail address you left while upgrading. Please use the account registered or linked to the e-mail address to <span class=\"loginMaskbtn\">login for using benefits</span>. If you haven't registered or linked an account with the e-mail address, please <span class=\"registerMaskbtn\">use the e-mail address to register an account</span> or link other accounts to this e-mail address for using benefits.",
    "GetStarted":"Get Started",
    "AccessTo":"Access to:",
    "imagesOfwatermarkremoval":"images of watermark removal",
    "upTo":"Up to",
    "perImage":"per image",
    "Support":"Support",
    "resolution":"resolution",
    "PrepaidPackage":"Prepaid Package",
    "PayasYouGo":"Pay as You Go",
    "TaxIncl":"Tax incl.",
    "Checkout":"Checkout",
    "imagesDay":"images/day",
    "imagesMonthly":"images/monthly",
    "image":"image",
    "images":"images",
    "imageSize":"image size",
    "buyInfo1":"Third-party <span>enhancer</span> integrations",
    "buyInfo2":"Editing history is valid for 7 days",
    "buyInfo3":"Priority processing",
    "buyInfo4":"7x24 customer support",
    "buyInfo5":"Expired after 24 hours",
    "buyInfo6":"No subscription. No auto-renew!",
    "buyInfo7":"Available for use anytime forever",
    "dayPlan":"1-Day Plan",
    "Lifetime":"Lifetime",
    "note":"<span>Note</span>: Please note that the purchased plan is tied to the email address provided during checkout. To use the plan successfully, register or log in with that same email address."
}